import module from './settings.module';
import './settings.controller';
import './services/settings.service';

export default module.name;